<script setup lang="ts">
import { ComboboxOption, ListboxOption } from '@headlessui/vue'
import type { Option } from './index.vue'

const props = defineProps<{
    option: Option
    selectable?: boolean
    autocomplete?: boolean
    selected?: boolean
    onSelect?: () => void
}>()

const emit = defineEmits<{
    (_e: 'select'): void
}>()

const hasSelectHandler = computed(() => {
    return props['onSelect'] !== undefined
})

function onClick(event: MouseEvent | KeyboardEvent) {
    if (!unref(hasSelectHandler)) return
    event.preventDefault()
    emit('select')
}
</script>

<template>
    <component
        :is="autocomplete ? ComboboxOption : ListboxOption"
        v-slot="{ active, selected: isSelected }"
        :value="option.value"
        as="template"
        :disabled="option.disabled"
    >
        <div
            :class="[
                option.disabled
                    ? 'italic text-gray'
                    : active || selected || isSelected
                    ? 'bg-gray text-black'
                    : 'text-black'
            ]"
            :data-value="option.value"
            :title="option.label"
            @click="onClick"
        >
            <div
                :class="[
                    selectable ? 'pl-10 pr-4' : 'px-4',
                    'relative cursor-pointer select-none py-2'
                ]"
            >
                <span
                    :style="{ paddingLeft: option.padding + 'px' }"
                    :class="[
                        selected || isSelected ? 'font-medium' : 'font-normal',
                        'block truncate'
                    ]"
                >
                    {{ option.label }}
                </span>

                <span
                    v-if="
                        selectable &&
                        !option.disabled &&
                        (selected || isSelected)
                    "
                    class="absolute inset-y-0 left-0 flex items-center pl-3 text-black"
                >
                    <CheckIcon class="h-5 w-5" aria-hidden="true" />
                </span>
            </div>
        </div>
    </component>
</template>